/* eslint-disable no-nested-ternary */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleProp, StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';
import { AppColors, CustomButtonShadow } from 'src/themes/Colors';
import { buttonSize, metrics } from 'src/themes/Metrics';
import { RegularText } from '../bases';

interface Props {
  row?: boolean;
  transparent?: boolean;
  onPress(): any;
  text: string;
  height?: keyof typeof buttonSize | number;
  style?: StyleProp<ViewStyle>;
  disabled?: boolean;
  backgroundColor?: string;
}

export const PrimaryButton = ({
  onPress,
  height = 'buttonNormal',
  style,
  text,
  row = false,
  transparent = false,
  disabled,
  backgroundColor,
}: Props) => {
  const { t } = useTranslation();

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      disabled={disabled}
      style={[
        row ? { flex: 1 } : { width: '100%' },
        {
          borderRadius: metrics.borderRadius,
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: disabled ? AppColors.gray : 'black',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: disabled ? AppColors.gray : transparent ? 'transparent' : backgroundColor || 'black',
          height: typeof height === 'number' ? height : buttonSize[height],
          ...CustomButtonShadow,
        },
        style,
      ]}
      onPress={onPress}>
      <RegularText fontWeight="bold" color={transparent ? 'black' : 'white'}>
        {t(text)}
      </RegularText>
    </TouchableOpacity>
  );
};
